import React, { useEffect, useState } from "react";
import parse from "html-react-parser";
import "./format-18.style.scss";
import { Container, Row } from "react-bootstrap";

const Format18 = (props) => {
  const [data, setData] = useState({});
  const [videoData, setVideoData] = useState(null);
  const [narasiData, setNarasiData] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    if (props?.item) {
      const item = props.item;
      setData(item);

      // Helper to safely parse JSON or return the value
      const smartParse = (val) => {
        if (!val) return null;
        if (typeof val === "object") return val;
        try {
          return JSON.parse(val);
        } catch (e) {
          return null;
        }
      };

      // 1. Parse link_video (for the grid)
      const vData = smartParse(item.link_video);
      setVideoData(vData);
      // 2. Parse Narasi (for the description section)
      // The narasi data is inside the parsed link_video object (vData)
      const nData = vData?.narasi || smartParse(item.narasi) || item.narasi;

      const finalData = {
        video: nData?.video || nData?.video_url || item.narasi_video || (typeof nData === "string" ? nData : null),
        banner: nData?.banner || nData?.banner_url || item.narasi_banner || item.image,
        thumbnail: nData?.thumbnail || nData?.image || item.image || "/assets/images/banner-video.png"
      };

      setNarasiData(finalData);
      console.log("Format 18 Narasi Data (Parsed):", finalData);
    }
  }, [props.item]);

  const checkValue = (val) => val && val !== "";
  const getYoutubeId = (url) => {
    const reg =
      /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i;
    const match = url?.match(reg);
    return match ? match[1] : null;
  };

  const VideoCard = ({ url, title, link, size, handleShowModalVideo, thumbnail }) => {
    const id = getYoutubeId(url);

    // tentukan src image
    let imageSrc = "/assets/images/banner-video.png";
    if (id) {
      imageSrc = `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
    } else if (thumbnail && thumbnail !== "" && thumbnail !== null) {
      imageSrc = thumbnail;
    } else if (url && !url.match(/\.(mp4|webm|ogg|mov)$/i)) {
      imageSrc = url;
    }

    return (
      <div className={`video-card ${size}`}>
        <div
          className="video-thumb"
          onClick={() =>
            handleShowModalVideo(true, { url, isYoutube: !!id })
          }
        >
          <img
            src={imageSrc}
            alt={title || "video"}
          />

          {/* play button hanya tampil kalau youtube */}
          {id && <span className="play-btn" />}
        </div>

        {title && link && (
          <a
            href={link}
            rel="noopener noreferrer"
            className="video-title"
          >
            {title}
          </a>
        )}
      </div>
    );
  };


  return (
    <Container bsPrefix="container-xl format-18" key={props.keyUniq}>
      <div className="content">
        {checkValue(props.item?.desc) && (
          <Row className="desc">
            <div className="narasi-container">
              <div className="narasi-video">
                {(() => {
                  const id = getYoutubeId(narasiData?.video);
                  if (id) {
                    return (
                      <div className="narasi-iframe-wrapper">
                        <iframe
                          src={`https://www.youtube.com/embed/${id}`}
                          title="video player"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      </div>
                    );
                  }
                  if (narasiData?.video && narasiData.video.match(/\.(mp4|webm|ogg|mov)$/i)) {
                    return (
                      <div
                        className={`narasi-video-wrapper ${isPlaying ? "playing" : ""}`}
                        onClick={(e) => {
                          const v = e.currentTarget.querySelector("video");
                          if (v && v.paused) v.play();
                        }}
                      >
                        <video
                          controls
                          onPlay={() => setIsPlaying(true)}
                          onPause={() => setIsPlaying(false)}
                        >
                          <source src={narasiData.video} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                        <div
                          className="play-overlay"
                          onClick={(e) => {
                            e.stopPropagation();
                            const v = e.currentTarget.parentElement.querySelector("video");
                            if (v) v.play();
                          }}
                        ></div>
                      </div>
                    );
                  }
                  return (
                    <VideoCard
                      url={narasiData?.video}
                      size="narasi"
                      handleShowModalVideo={props.handleShowModalVideo}
                      thumbnail={narasiData?.thumbnail}
                    />
                  );
                })()}
              </div>
              <div className="narasi-right">
                <div className="narasi-banner">
                  <img
                    src={narasiData?.banner || "/assets/images/logo.png"}
                    alt="banner"
                  />
                </div>
                <div className="narasi-text">{parse(props.item.desc)}</div>
              </div>
            </div>
          </Row>
        )}

        <div className="section-divider"></div>

        {videoData && (
          <Row className="video-gallery-wrapper">
            <div className="main-grid">
              {Object.values(videoData.main || {}).map((url, i) => (
                <VideoCard
                  key={i}
                  url={url}
                  size="main"
                  handleShowModalVideo={props.handleShowModalVideo}
                />
              ))}
            </div>

            <section
              className="highlight-section"
              style={{
                "--highlight-bg": videoData?.background
                  ? `url(${videoData.background})`
                  : null
              }}
            >
              <div className="highlight-bg">
                {checkValue(props.item?.short_desc) && (
                  <h2>{parse(props.item.short_desc)}</h2>
                )}
                <div className="highlight-grid">
                  {(videoData.highlights || []).map((item, i) => (
                    <VideoCard
                      key={i}
                      url={item.video}
                      title={item.title}
                      link={item.web}
                      size="highlight"
                      handleShowModalVideo={props.handleShowModalVideo}
                    />
                  ))}
                </div>
              </div>
            </section>
          </Row>
        )}
      </div>
    </Container>
  );
};

export default Format18
